import { deactivatePushSubscription } from "@/features/push/services/push-api";
import { isPushSupported } from "@/features/push/lib/push-utils";

/**
 * Deactivate ONLY this device's push subscription, then unsubscribe locally.
 * Best-effort and non-blocking: never throws, so it is safe to await before sign-out.
 * Must not deactivate other devices/sessions.
 */
export async function deactivateCurrentDevicePush(): Promise<void> {
  try {
    if (!isPushSupported()) return;

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) return;

    // Tell the backend first (while we are still authenticated), then unsubscribe locally.
    await deactivatePushSubscription(subscription.endpoint).catch(() => undefined);
    await subscription.unsubscribe().catch(() => undefined);
  } catch {
    // Swallow: push cleanup must never block sign-out.
  }
}
